<script lang="ts" generics="T">
	import LoadingIndicator from '@astlai/common/LoadingIndicator.svelte';

	interface Option {
		label: string;
		value: T;
		primary?: boolean;
		loading?: boolean;
	}

	interface Props {
		options: Option[];
		onselect: (value: T) => void;
		disabled?: boolean;
	}

	const { options, onselect, disabled = false }: Props = $props();
</script>

<div class="antonio-buttons">
	{#each options as option (option.value)}
		<button
			class="large"
			class:accent={option.primary}
			type="button"
			disabled={disabled || option.loading}
			onclick={() => onselect(option.value)}
		>
			{#if option.loading}
				<LoadingIndicator />
			{:else}
				{option.label}
			{/if}
		</button>
	{/each}
</div>

<style lang="scss">
	@use '@astlai/common/styles/mixins' as lib;

	.antonio-buttons {
		@include lib.flex-row();
		flex-wrap: wrap;
		gap: 0.5rem;
		padding: 0.5rem 0;

		button {
			&:first-child {
				flex: 1 1 66%;
			}
			flex: 1 1 33%;
		}
	}
</style>
